import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IPost } from '@/Module/Post/Model/DataModel';
import { PostService } from '@/Module/Post/Service';

export const getPostListAction = createAsyncThunk<IPost[]>('post/getList', async (_, { signal }) => {
  return PostService.getList(signal, {
    disabledAutoError: true,
  }).then(({ data }) => data);
});
